import React from 'react';
import PropTypes from 'prop-types';
import './FloorButton.css';
import SimpleButton from 'components/shared/button/SimpleButton';
import plusIconPng from 'images/plus-icon.png';
import removeIconPng from 'images/remove.svg';

export default function FloorButton(props) {
  const handleClick = () => {
    if (props.onClick && !props.disabled) {
      props.onClick();
    }
  };

  return (
    <SimpleButton
      className="add-floors-button"
      disabled={props.disabled}
      img={props.isForAdd ? plusIconPng : removeIconPng}
      label={`${props.isForAdd ? 'Add' : 'Remove'} floor`}
      onClick={handleClick}
    />
  );
}

FloorButton.propTypes = {
  disabled: PropTypes.bool,
  isForAdd: PropTypes.bool,
  onClick: PropTypes.func,
};

FloorButton.defaultProps = {
  disabled: false,
  isForAdd: false,
};



// WEBPACK FOOTER //
// ./src/components/shared/button/FloorButton.js